import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const OrderFormPage = lazy(() => import('./OrderForm.page'));

export const OrderForm = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <OrderFormPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
